import React from 'react';
import { Shield, Swords, ScrollText, Users, Crown, LogIn, UserPlus, ChevronDown, CheckCircle2, XCircle } from 'lucide-react';
const portrait  = './img/roster/portrait.png';


// --- COMPOSANT PRINCIPAL DE L'APPLICATION ---
const App = () => {
    // --- SVG CUSTOM ICON ---
    const AxeIcon = (props) => (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
            <path d="M14.5 2H18a2 2 0 0 1 2 2v2.5L13 13.5V10h-2v3.5L4 20.5V18a2 2 0 0 1 2-2h2.5" />
            <path d="m20 8-8 8" />
            <path d="M9.5 14.5 16 8" />
        </svg>
    );

    // --- MOCK DATA ---
    const ROSTER_DATA = [
      { id: 1, name: 'Astrée', class: 'Guerrier', rank: 'Warchief', spec: 'Arms', ilvl: 528, quote: "Strength and honor!", img: 'https://files.catbox.moe/9jpvfx.png' },
      { id: 2, name: 'Astrée', class: 'Chasseur', rank: 'Warlord', spec: 'Survival', ilvl: 525, quote: "For the Amani!", img: 'portraits/2' },
      { id: 3, name: 'Astrée', class: 'Chaman', rank: 'Raider', spec: 'Enhancement', ilvl: 524, quote: "The spirits be with me.", img: 'portraits/3' },
      { id: 4, name: 'Astrée', class: 'Voleur', rank: 'Assassin', spec: 'Assassination', ilvl: 526, quote: "Victory or death.", img: 'portraits/4' },
      { id: 5, name: 'Astrée', class: 'Chaman', rank: 'Raider', spec: 'Elemental', ilvl: 523, quote: "The elements guide me.", img: 'portraits/5' },
      { id: 6, name: 'Astrée', class: 'Prêtre', rank: 'Raider', spec: 'Shadow', ilvl: 519, quote: "The Horde is my family.", img: 'portraits/6' },
      { id: 7, name: 'Astrée', class: 'Chasseur', rank: 'Warlord', spec: 'Marksmanship', ilvl: 529, quote: "We are the Forsaken.", img: 'portraits/7' },
    ];

    const RAID_PROGRESS_DATA = {
        orgrimmar: {
            name: "Astrée",
            bosses: [
              { name: 'Astrée', nm: true, hm: true, mm: true, img: 'abstract/1' },
              { name: 'Astrée', nm: true, hm: true, mm: true, img: 'abstract/2' },
              { name: 'Astrée', nm: true, hm: true, mm: true, img: 'abstract/3' },
              { name: 'Astrée', nm: true, hm: true, mm: true, img: 'abstract/4' },
              { name: 'Astrée', nm: true, hm: true, mm: false, img: 'abstract/5' },
              { name: 'Astrée', nm: true, hm: true, mm: false, img: 'abstract/6' },
              { name: 'Astrée', nm: true, hm: false, mm: false, img: 'abstract/7' },
            ],
        },
        hellfire: {
            name: "Astrée2",
            bosses: [
                { name: 'Astrée', nm: true, hm: true, mm: true, img: 'nature/1' },
                { name: 'Astrée', nm: true, hm: true, mm: true, img: 'people/1' },
                { name: 'Astrée', nm: true, hm: true, mm: true, img: 'animals/1' },
                { name: 'Astrée', nm: true, hm: true, mm: false, img: 'people/2' },
                { name: 'Astrée', nm: true, hm: true, mm: false, img: 'people/3' },
                { name: 'Astrée', nm: true, hm: true, mm: false, img: 'people/4' },
            ],
        },
    };

    const NEWS_DATA = [
      { id: 1, title: 'Astrée Defeated!', date: '2025-08-28', content: "flemme d'écrire", author: 'Astrée' },
      { id: 2, title: 'Call to Arms! Recruitment Open!', date: '2025-08-22', content: "flemme d'écrire ", author: 'Astrée' },
    ];

    const RECRUITMENT_DATA = {
        tanks: { needed: 'low', classes: ['Guerrier', 'Chevalier de la mort'] },
        healers: { needed: 'high', classes: ['Chaman', 'Prêtre'] },
        dps: { needed: 'medium', classes: ['Mage', 'Démoniste', 'Chasseur'] },
    };

    const CLASS_COLORS = {
        'Guerrier': '#C79C6E', 'Chasseur': '#ABD473', 'Chaman': '#0070DE', 'Voleur': '#FFF569',
        'Prêtre': '#FFFFFF', 'Chevalier de la mort': '#C41F3B', 'Mage': '#69CCF0', 'Démoniste': '#9482C9'
    };

    // --- SOUS-COMPOSANTS ---

    const SmolderingEmbersBackground = () => {
        const canvasRef = React.useRef(null);

        React.useEffect(() => {
            const canvas = canvasRef.current;
            const ctx = canvas.getContext('2d');
            let animationFrameId;
            let particles = [];
            const numParticles = 100;

            const handleResize = () => {
                canvas.width = window.innerWidth;
                canvas.height = window.innerHeight;
                particles = [];
                for (let i = 0; i < numParticles; i++) {
                    particles.push({
                        x: Math.random() * canvas.width,
                        y: canvas.height + Math.random() * 100,
                        size: Math.random() * 3 + 1,
                        speedY: Math.random() * 1 + 0.5,
                        speedX: Math.random() * 2 - 1,
                        color: `rgba(255, ${Math.floor(Math.random() * 100 + 100)}, 0, ${Math.random() * 0.5 + 0.2})`
                    });
                }
            };

            const animate = () => {
                ctx.clearRect(0, 0, canvas.width, canvas.height);
                
                particles.forEach(p => {
                    p.y -= p.speedY;
                    p.x += p.speedX;
                    
                    if (p.y < -10) {
                        p.y = canvas.height + 10;
                        p.x = Math.random() * canvas.width;
                    }

                    ctx.beginPath();
                    ctx.arc(p.x, p.y, p.size, 0, Math.PI * 2);
                    ctx.fillStyle = p.color;
                    ctx.shadowColor = '#ff4500';
                    ctx.shadowBlur = 15;
                    ctx.fill();
                });

                animationFrameId = requestAnimationFrame(animate);
            };

            handleResize();
            animate();
            window.addEventListener('resize', handleResize);

            return () => {
                cancelAnimationFrame(animationFrameId);
                window.removeEventListener('resize', handleResize);
            };
        }, []);

        return <canvas ref={canvasRef} className="embers-canvas" />;
    };

    const Header = ({ navigate, currentPage }) => {
        const navLinks = [
            { id: 'home', label: 'Accueil', Icon: Swords },
            { id: 'roster', label: 'Roster', Icon: Users },
            { id: 'progress', label: 'Progress', Icon: Shield },
            { id: 'news', label: 'News', Icon: ScrollText },
            { id: 'recruitment', label: 'Recrutement', Icon: UserPlus },
            { id: 'user-panel', label: 'Panel', Icon: LogIn },
        ];

        return (
            <header className="app-header">
                <div className="container header-container">
                    <div className="logo-group" onClick={() => navigate('home')}>
                        <AxeIcon className="logo-icon" />
                        <span className="logo-text">Illivium</span>
                    </div>
                    <nav className="main-nav">
                        {navLinks.map(({ id, label, Icon }) => (
                            <button
                                key={id}
                                onClick={() => navigate(id)}
                                className={`nav-button ${currentPage === id ? 'active' : ''}`}
                            >
                                <Icon size={16} />
                                {label}
                            </button>
                        ))}
                    </nav>
                </div>
            </header>
        );
    };

    const HomePage = ({ className, navigate }) => (
        <div className={`home-page ${className}`}>
            <h1 className="home-title" style={{ textShadow: '0 0 30px rgba(220, 38, 38, 0.7)' }}>
                Illivium
            </h1>
            <p className="home-subtitle">
                FORCE ET HONNEUR
            </p>
            <div className="home-actions">
                <button onClick={() => navigate('progress')} className="btn btn-primary">
                    Voir la Progression
                </button>
                <button onClick={() => navigate('recruitment')} className="btn btn-secondary">
                    Nous Rejoindre
                </button>
            </div>
        </div>
    );

    const RosterPage = ({ className }) => (
        <div className={className}>
            <h2 className="page-title" style={{ textShadow: '0 0 15px rgba(220, 38, 38, 0.5)' }}>Nos Guerriers</h2>
            <div className="roster-grid">
                {ROSTER_DATA.map(member => (
                    <div key={member.id} className="member-card">
                        <img 
                            src={member.id === 1 ? 'https://files.catbox.moe/9jpvfx.png' : `https://placehold.co/400x533/262626/dc2626?text=${member.name}`} 
                            alt={member.name} 
                            className="member-card-img" 
                        />
                        <div className="member-card-overlay"></div>
                        <div className="member-card-content">
                            <div className="member-card-info">
                                <h3 className="member-name" style={{ color: CLASS_COLORS[member.class] || '#FFFFFF' }}>{member.name}</h3>
                                <p className="member-rank">{member.rank}</p>
                                <div className="member-details">
                                    <span className="member-spec">{member.spec}</span>
                                    <span className="member-ilvl">{member.ilvl}</span>
                                </div>
                            </div>
                            <div className="member-card-quote">
                                <p>"{member.quote}"</p>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );

    const RaidProgressPage = ({ className }) => {
        const raidKeys = Object.keys(RAID_PROGRESS_DATA);
        const [selectedRaidKey, setSelectedRaidKey] = React.useState(raidKeys[0]);
        const selectedRaid = RAID_PROGRESS_DATA[selectedRaidKey];

        return (
            <div className={className}>
                <h2 className="page-title" style={{ textShadow: '0 0 15px rgba(220, 38, 38, 0.5)' }}>Progression des Raids</h2>
                <div className="raid-select-wrapper">
                    <div className="raid-select-container">
                        <select value={selectedRaidKey} onChange={(e) => setSelectedRaidKey(e.target.value)} className="raid-select">
                            {raidKeys.map(key => <option key={key} value={key}>{RAID_PROGRESS_DATA[key].name}</option>)}
                        </select>
                        <ChevronDown size={20} className="raid-select-arrow" />
                    </div>
                </div>
                {selectedRaid && (
                    <div className="progress-card">
                        <h3 className="progress-raid-title">{selectedRaid.name}</h3>
                        <div className="progress-grid">
                            {selectedRaid.bosses.map((boss) => (
                                <div key={boss.name} className={`boss-card ${boss.nm ? 'defeated' : 'undefeated'}`}>
                                    <div className={`boss-image-container ${!boss.nm && 'grayscale'}`}>
                                       <img src={`https://placehold.co/400x225/262626/dc2626?text=${boss.name.replace(/\s/g,'+')}`} alt={boss.name} className="boss-image"/>
                                       <div className="boss-image-overlay"></div>
                                    </div>
                                    <div className="boss-info">
                                        <h4 className="boss-name">{boss.name}</h4>
                                        <div className="boss-difficulties">
                                            <div className={`difficulty-status ${boss.nm ? 'nm-defeated' : ''}`}>
                                                {boss.nm ? <CheckCircle2 size={14} /> : <XCircle size={14} />} NM
                                            </div>
                                            <div className={`difficulty-status ${boss.hm ? 'hm-defeated' : ''}`}>
                                                {boss.hm ? <CheckCircle2 size={14} /> : <XCircle size={14} />} HM
                                            </div>
                                            <div className={`difficulty-status ${boss.mm ? 'mm-defeated' : ''}`}>
                                                {boss.mm ? <CheckCircle2 size={14} /> : <XCircle size={14} />} MM
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        );
    };

    const NewsPage = ({ className }) => (
        <div className={className}>
            <h2 className="page-title" style={{ textShadow: '0 0 15px rgba(220, 38, 38, 0.5)' }}>Cri de Guerre</h2>
            <div className="news-container">
                {NEWS_DATA.map(article => (
                    <article key={article.id} className="news-article">
                        <h3 className="news-title">{article.title}</h3>
                        <div className="news-meta">{article.date} &bull; par {article.author}</div>
                        <p className="news-content">{article.content}</p>
                    </article>
                ))}
            </div>
        </div>
    );

    const RecruitmentPage = ({ className }) => {
        const getNeededClass = (level) => {
            switch (level) {
                case 'high': return 'priority-high';
                case 'medium': return 'priority-medium';
                case 'low': return 'priority-low';
                default: return '';
            }
        };
        const getNeededLabel = (level) => ({ high: 'Haute Priorité', medium: 'Priorité Moyenne', low: 'Basse Priorité' }[level] || 'Fermé');

        return (
            <div className={className}>
                <h2 className="page-title" style={{ textShadow: '0 0 15px rgba(220, 38, 38, 0.5)' }}>Recrutement</h2>
                <div className="recruitment-card">
                    <p className="recruitment-intro">La Horde a besoin de vous !</p>
                    <div className="recruitment-grid">
                        {Object.entries(RECRUITMENT_DATA).map(([role, data]) => (
                            <div key={role} className={`role-card ${getNeededClass(data.needed)}`}>
                                <h3 className="role-title">{role}</h3>
                                <p className="role-priority">{getNeededLabel(data.needed)}</p>
                                <div className="role-classes">
                                    {data.classes.map(c => <span key={c} className="class-tag" style={{ backgroundColor: `${CLASS_COLORS[c]}30`, color: CLASS_COLORS[c] || '#FFFFFF' }}>{c}</span>)}
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className="recruitment-apply">
                        <h3 className="apply-title">Rejoignez le combat !</h3>
                        <p className="apply-text">Les candidatures de guerriers exceptionnels sont toujours étudiées.</p>
                        <button className="btn btn-primary">
                            Postuler
                        </button>
                    </div>
                </div>
            </div>
        );
    };

    const UserPanelPage = ({ user, setUser, className }) => (
        <div className={className}>
            <h2 className="page-title" style={{ textShadow: '0 0 15px rgba(220, 38, 38, 0.5)' }}>Panel Utilisateur</h2>
            <div className="user-panel-card">
                <div className="simulation-box">
                    <h4 className="simulation-title">Simulation de Connexion</h4>
                    <div className="simulation-controls">
                        <button onClick={() => setUser({ ...user, loggedIn: !user.loggedIn })} className="btn btn-secondary-sm">
                            {user.loggedIn ? 'Se déconnecter' : 'Se connecter'}
                        </button>
                        {user.loggedIn && (
                            <div className="role-selector">
                                <span className="role-label">Rôle:</span>
                                <select value={user.role} onChange={(e) => setUser({ ...user, role: e.target.value })} className="role-select">
                                    <option value="guest">Invité</option>
                                    <option value="member">Membre</option>
                                    <option value="officer">Officier</option>
                                </select>
                            </div>
                        )}
                    </div>
                </div>
                {!user.loggedIn ? (
                    <div className="logged-out-view">
                        <LogIn className="logged-out-icon" />
                        <h3 className="logged-out-text">Vous n'êtes pas connecté.</h3>
                    </div>
                ) : (
                    <div>
                        <h3 className="welcome-message">Bienvenue, <span className="user-role">{user.role}</span> !</h3>
                        <p className="options-text">Options disponibles pour votre rang :</p>
                        {(user.role === 'member' || user.role === 'officer') && (
                            <div className="permission-box member-box">
                                <h4 className="permission-title"><Users size={20}/> Espace Membre</h4>
                                <ul className="permission-list">
                                    <li>Consulter le calendrier des raids</li>
                                    <li>S'inscrire aux événements</li>
                                </ul>
                            </div>
                        )}
                        {user.role === 'officer' && (
                            <div className="permission-box officer-box">
                                <h4 className="permission-title officer-title"><Crown size={20}/> Panel Officier</h4>
                                <ul className="permission-list">
                                    <li>Gérer le roster de la guilde</li>
                                    <li>Publier une nouvelle actualité</li>
                                </ul>
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    );

    const Footer = () => (
        <footer className="app-footer">
            <div className="container">
                <p>&copy; {new Date().getFullYear()} Illivium. Pour la Horde !</p>
            </div>
        </footer>
    );

    // --- LOGIQUE PRINCIPALE DE L'APPLICATION ---
    const [currentPage, setCurrentPage] = React.useState('home');
    const [user, setUser] = React.useState({ loggedIn: false, role: 'guest' });

    const navigate = (page) => {
        setCurrentPage(page);
        window.scrollTo(0, 0);
    };

    const renderPage = () => {
        const pageClassName = "container page-content animate-fade-in";
        switch (currentPage) {
            case 'roster': return <RosterPage className={pageClassName} />;
            case 'progress': return <RaidProgressPage className={pageClassName} />;
            case 'news': return <NewsPage className={pageClassName} />;
            case 'recruitment': return <RecruitmentPage className={pageClassName} />;
            case 'user-panel': return <UserPanelPage user={user} setUser={setUser} className={pageClassName} />;
            case 'home':
            default: return <HomePage className={pageClassName} navigate={navigate} />;
        }
    };

    return (
        <div className="app-root">
            <style>{`
                /* --- GENERAL & FONT STYLES --- */
                @import url('https://fonts.googleapis.com/css2?family=Oswald:wght@400;700&display=swap');
                
                :root {
                  --color-red-400: #f87171;
                  --color-red-500: #ef4444;
                  --color-red-600: #dc2626;
                  --color-red-700: #b91c1c;
                  --color-red-800: #991b1b;
                  --color-red-900: #7f1d1d;
                  --color-slate-300: #cbd5e1;
                  --color-slate-400: #94a3b8;
                  --color-slate-500: #64748b;
                  --color-slate-600: #475569;
                  --color-slate-700: #334155;
                  --color-slate-800: #1e293b;
                  --color-slate-900: #0f172a;
                  --color-slate-950: #020617;
                }

                * {
                  box-sizing: border-box;
                  margin: 0;
                  padding: 0;
                }

                body { 
                  font-family: 'Oswald', sans-serif; 
                  background-color: #000;
                  color: #fff;
                }

                h1, h2, h3, h4, button, select, input { 
                  font-family: 'Oswald', sans-serif;
                  text-transform: uppercase; 
                }

                .app-root {
                  background-color: #000;
                  color: #fff;
                }

                .container {
                  width: 100%;
                  margin-left: auto;
                  margin-right: auto;
                  padding-left: 1rem;
                  padding-right: 1rem;
                }
                
                .page-content {
                  padding-top: 3rem;
                  padding-bottom: 3rem;
                }

                .page-title {
                    font-size: 2.25rem;
                    font-weight: 900;
                    text-align: center;
                    color: #fff;
                    margin-bottom: 3rem;
                    text-transform: uppercase;
                }
                
                @keyframes fadeIn {
                    from { opacity: 0; transform: translateY(10px); }
                    to { opacity: 1; transform: translateY(0); }
                }

                @keyframes glow {
                    0%, 100% {
                        box-shadow: 0 0 8px rgba(220, 38, 38, 0.5);
                        border-color: rgba(220, 38, 38, 0.7);
                    }
                    50% {
                        box-shadow: 0 0 16px rgba(248, 113, 113, 0.6);
                        border-color: rgba(248, 113, 113, 1);
                    }
                }
                
                .animate-fade-in { 
                  animation: fadeIn 0.5s ease-out forwards; 
                }

                /* --- LAYOUT WRAPPER --- */
                .app-wrapper {
                  position: relative;
                  z-index: 10;
                  display: flex;
                  flex-direction: column;
                  min-height: 100vh;
                }

                .main-content {
                  flex-grow: 1;
                  display: flex;
                  flex-direction: column;
                }

                /* --- CANVAS BACKGROUND --- */
                .embers-canvas {
                  position: fixed;
                  top: 0;
                  left: 0;
                  width: 100%;
                  height: 100%;
                  z-index: 0;
                  background-image: linear-gradient(to top, #1a0000, #2b0f0e, #1e1e24);
                }

                /* --- HEADER --- */
                .app-header {
                  background-color: rgba(0,0,0,0.5);
                  backdrop-filter: blur(4px);
                  border-bottom: 4px solid var(--color-red-800);
                  box-shadow: 0 10px 15px -3px rgba(127, 29, 29, 0.3), 0 4px 6px -2px rgba(127, 29, 29, 0.2);
                }

                .header-container {
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  height: 5rem;
                }

                .logo-group {
                  display: flex;
                  align-items: center;
                  gap: 1rem;
                  cursor: pointer;
                }

                .logo-icon {
                  height: 4rem;
                  width: 4rem;
                  color: var(--color-red-500);
                  padding: 0.75rem;
                  background-color: rgba(30, 41, 59, 0.5);
                  border-radius: 9999px;
                  transition: all 0.3s;
                  border: 2px solid var(--color-slate-700);
                }
                .logo-group:hover .logo-icon {
                  transform: scale(1.1);
                  box-shadow: 0 0 25px rgba(220, 38, 38, 0.6);
                  border-color: var(--color-red-600);
                }

                .logo-text {
                  font-size: 2.25rem;
                  font-weight: 800;
                  color: #fff;
                  letter-spacing: 0.05em;
                  text-transform: uppercase;
                  transition: color 0.3s;
                  text-shadow: 2px 2px 5px rgba(0,0,0,0.9);
                }
                .logo-group:hover .logo-text {
                  color: var(--color-red-500);
                }

                .main-nav {
                  display: none;
                  align-items: center;
                  background-color: rgba(15, 23, 42, 0.5);
                  border: 1px solid var(--color-slate-700);
                  border-radius: 0.375rem;
                  padding: 0.25rem;
                }
                
                .nav-button {
                  padding: 0.5rem 1rem;
                  font-size: 0.875rem;
                  font-weight: 600;
                  border-radius: 0.375rem;
                  transition: all 0.3s;
                  display: flex;
                  align-items: center;
                  gap: 0.5rem;
                  color: var(--color-slate-300);
                  background: none;
                  border: none;
                  cursor: pointer;
                }
                .nav-button:hover {
                  background-color: rgba(51, 65, 85, 0.5);
                  color: #fff;
                }
                .nav-button.active {
                  background-color: rgba(220, 38, 38, 0.3);
                  color: var(--color-red-400);
                }
                
                /* --- BUTTONS --- */
                .btn {
                    font-weight: 700;
                    padding: 0.75rem 2rem;
                    border-radius: 0.5rem;
                    transition: all 0.3s;
                    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
                    border-bottom-width: 4px;
                    cursor: pointer;
                }
                .btn:hover {
                    transform: scale(1.05);
                }
                .btn-primary {
                    background-color: var(--color-red-700);
                    color: white;
                    border-color: var(--color-red-900);
                    box-shadow: 0 10px 15px -3px rgba(185, 28, 28, 0.3), 0 4px 6px -2px rgba(185, 28, 28, 0.2);
                }
                .btn-primary:hover {
                    background-color: var(--color-red-600);
                    border-color: var(--color-red-800);
                    box-shadow: 0 10px 15px -3px rgba(185, 28, 28, 0.5), 0 4px 6px -2px rgba(185, 28, 28, 0.3);
                }
                .btn-secondary {
                    background-color: rgba(30, 41, 59, 0.5);
                    color: white;
                    border-color: var(--color-slate-900);
                    box-shadow: 0 10px 15px -3px rgba(0,0,0,0.5), 0 4px 6px -2px rgba(0,0,0,0.3);
                }
                .btn-secondary:hover {
                    background-color: rgba(51, 65, 85, 0.5);
                    border-color: var(--color-slate-800);
                }
                .btn-secondary-sm {
                  background-color: var(--color-slate-600);
                  color: white;
                  padding: 0.5rem 1rem;
                  border-radius: 0.375rem;
                  font-size: 0.875rem;
                  font-weight: 600;
                  border: none;
                  cursor: pointer;
                }
                .btn-secondary-sm:hover {
                  background-color: var(--color-slate-500);
                }

                /* --- HOME PAGE --- */
                .home-page {
                  text-align: center;
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  justify-content: center;
                  flex-grow: 1;
                }
                .home-title {
                  font-size: 3.75rem;
                  font-weight: 900;
                  color: white;
                  text-transform: uppercase;
                  letter-spacing: 0.1em;
                }
                .home-subtitle {
                  margin-top: 1rem;
                  max-width: 42rem;
                  font-size: 1.25rem;
                  color: rgba(248, 113, 113, 0.8);
                  font-weight: 700;
                  letter-spacing: 0.05em;
                }
                .home-actions {
                  margin-top: 2.5rem;
                  display: flex;
                  flex-wrap: wrap;
                  justify-content: center;
                  gap: 1rem;
                }

                /* --- ROSTER PAGE --- */
                .roster-grid {
                  display: grid;
                  grid-template-columns: repeat(1, 1fr);
                  gap: 2rem;
                }
                .member-card {
                  position: relative;
                  aspect-ratio: 3 / 4;
                  overflow: hidden;
                  border-radius: 0.5rem;
                  border: 2px solid rgba(30, 41, 59, 0.5);
                  box-shadow: 0 10px 15px -3px rgba(0,0,0,0.1), 0 4px 6px -2px rgba(0,0,0,0.05);
                  transition: all 0.3s;
                }
                .member-card:hover {
                  border-color: rgba(220, 38, 38, 0.5);
                  box-shadow: 0 25px 50px -12px rgba(220, 38, 38, 0.2);
                  transform: translateY(-0.5rem);
                }
                .member-card-img {
                  position: absolute;
                  inset: 0;
                  width: 100%;
                  height: 100%;
                  object-fit: cover;
                  object-position: center; /* Ajouté cette ligne */
                  transition: transform 0.3s;
                }
                .member-card:hover .member-card-img {
                  transform: scale(1.1);
                }
                .member-card-overlay {
                  position: absolute;
                  inset: 0;
                  background-image: linear-gradient(to top, rgba(0,0,0,0.95), rgba(0,0,0,0.7), transparent);
                }
                .member-card-content {
                  position: absolute;
                  inset: 0;
                  display: flex;
                  flex-direction: column;
                  justify-content: flex-end;
                  padding: 1rem;
                }
                .member-card-info {
                  transition: transform 0.3s;
                }
                .member-card:hover .member-card-info {
                  transform: translateY(-2.5rem);
                }
                .member-name { font-size: 1.5rem; font-weight: 700; }
                .member-rank { font-size: 0.875rem; font-weight: 600; color: var(--color-slate-300); }
                .member-details { display: flex; align-items: center; justify-content: space-between; margin-top: 0.5rem; }
                .member-spec { font-size: 0.75rem; font-weight: 700; padding: 0.25rem 0.5rem; border-radius: 0.375rem; background-color: rgba(15, 23, 42, 0.5); border: 1px solid var(--color-slate-700); }
                .member-ilvl { font-size: 1.125rem; font-weight: 700; color: var(--color-red-500); }
                .member-card-quote {
                  position: absolute;
                  bottom: 1rem;
                  left: 1rem;
                  right: 1rem;
                  opacity: 0;
                  transition: opacity 0.3s;
                  font-size: 0.875rem;
                  font-style: italic;
                  color: rgba(252, 165, 165, 0.9);
                }
                .member-card:hover .member-card-quote {
                  opacity: 1;
                }
                
                /* --- RAID PROGRESS PAGE --- */
                .raid-select-wrapper { max-width: 36rem; margin: 0 auto 2rem auto; }
                .raid-select-container { position: relative; }
                .raid-select {
                  width: 100%;
                  appearance: none;
                  background-color: rgba(15, 23, 42, 0.5);
                  border: 2px solid rgba(185, 28, 28, 0.3);
                  color: white;
                  border-radius: 0.5rem;
                  padding: 0.75rem 1rem;
                  font-weight: 700;
                  font-size: 1.125rem;
                  transition: border-color 0.2s;
                }
                .raid-select:focus { outline: none; border-color: var(--color-red-600); }
                .raid-select-arrow {
                  pointer-events: none;
                  position: absolute;
                  top: 50%;
                  right: 0.75rem;
                  transform: translateY(-50%);
                  color: var(--color-red-400);
                }
                .progress-card {
                  background-color: rgba(15, 23, 42, 0.3);
                  backdrop-filter: blur(4px);
                  border-radius: 0.5rem;
                  box-shadow: 0 10px 15px -3px rgba(0,0,0,0.1);
                  padding: 1.5rem;
                  max-width: 72rem;
                  margin: auto;
                  border: 1px solid rgba(185, 28, 28, 0.2);
                }
                .progress-raid-title {
                  font-size: 1.875rem;
                  font-weight: 700;
                  text-align: center;
                  color: var(--color-red-500);
                  margin-bottom: 2rem;
                }
                .progress-grid {
                  display: grid;
                  grid-template-columns: repeat(1, 1fr);
                  gap: 1.25rem;
                }
                .boss-card {
                  border-radius: 0.5rem;
                  border-width: 2px;
                  transition: all 0.3s;
                }
                .boss-card.defeated { border-color: rgba(185, 28, 28, 0.5); background-color: rgba(15, 23, 42, 0.7); }
                .boss-card.undefeated { border-color: var(--color-slate-800); background-color: rgba(15, 23, 42, 0.4); }
                .boss-card:hover { transform: translateY(-0.25rem); box-shadow: 0 25px 50px -12px rgba(220, 38, 38, 0.2); }
                .boss-image-container { position: relative; aspect-ratio: 16/9; width: 100%; border-top-left-radius: 0.375rem; border-top-right-radius: 0.375rem; overflow: hidden; }
                .boss-image-container.grayscale { filter: grayscale(100%); opacity: 0.5; }
                .boss-image { width: 100%; height: 100%; object-fit: cover; transition: transform 0.3s; }
                .boss-card:hover .boss-image { transform: scale(1.1); }
                .boss-image-overlay { position: absolute; inset: 0; background-image: linear-gradient(to top, rgba(0,0,0,0.8), transparent); }
                .boss-info { padding: 1rem; }
                .boss-name { font-weight: 700; font-size: 1.125rem; }
                .boss-card.undefeated .boss-name { color: var(--color-slate-500); }
                .boss-difficulties { display: flex; align-items: center; justify-content: space-between; margin-top: 0.75rem; }
                .difficulty-status { display: flex; align-items: center; gap: 0.25rem; font-size: 0.75rem; font-weight: 600; color: var(--color-slate-600); }
                .difficulty-status.nm-defeated { color: #4ade80; }
                .difficulty-status.hm-defeated { color: #38bdf8; }
                .difficulty-status.mm-defeated { color: #c084fc; }

                /* --- NEWS PAGE --- */
                .news-container {
                  display: flex;
                  flex-direction: column;
                  gap: 1.5rem;
                  max-width: 48rem;
                  margin: auto;
                }
                .news-article {
                  background-color: rgba(15, 23, 42, 0.5);
                  backdrop-filter: blur(4px);
                  border-radius: 0.5rem;
                  box-shadow: 0 10px 15px -3px rgba(0,0,0,0.1);
                  padding: 1.5rem;
                  border-left: 4px solid rgba(185, 28, 28, 0.5);
                  transition: border-color 0.2s;
                }
                .news-article:hover {
                  border-color: var(--color-red-600);
                }
                .news-title { font-size: 1.25rem; font-weight: 700; color: var(--color-red-500); }
                .news-meta { font-size: 0.875rem; color: var(--color-slate-400); margin-top: 0.25rem; margin-bottom: 0.5rem; }
                .news-content { color: var(--color-slate-300); line-height: 1.6; }
                
                /* --- RECRUITMENT PAGE --- */
                .recruitment-card {
                  max-width: 56rem;
                  margin: auto;
                  background-color: rgba(15, 23, 42, 0.5);
                  backdrop-filter: blur(4px);
                  border-radius: 0.5rem;
                  box-shadow: 0 10px 15px -3px rgba(0,0,0,0.1);
                  padding: 2rem;
                  border: 1px solid rgba(185, 28, 28, 0.2);
                }
                .recruitment-intro { text-align: center; font-size: 1.125rem; color: var(--color-slate-300); margin-bottom: 2rem; font-weight: 700; letter-spacing: 0.05em; }
                .recruitment-grid { display: grid; grid-template-columns: repeat(1, 1fr); gap: 1.5rem; text-align: center; }
                .role-card { padding: 1rem; border-radius: 0.5rem; border-width: 2px; transition: all 0.3s; }
                .role-card.priority-high { 
                    color: var(--color-red-400); 
                    background-color: rgba(220, 38, 38, 0.1); 
                    animation: glow 2.5s infinite ease-in-out;
                }
                .role-card.priority-medium { border-color: rgba(249, 115, 22, 0.5); background-color: rgba(249, 115, 22, 0.1); color: #fb923c; }
                .role-card.priority-low { border-color: rgba(71, 85, 105, 0.5); background-color: rgba(100, 116, 139, 0.1); color: var(--color-slate-300); }
                .role-title { font-size: 1.125rem; font-weight: 700; text-transform: capitalize; margin-bottom: 0.5rem; }
                .role-priority { font-weight: 600; margin-bottom: 0.75rem; font-size: 0.875rem; }
                .role-classes { display: flex; flex-wrap: wrap; justify-content: center; gap: 0.5rem; }
                .class-tag { padding: 0.25rem 0.5rem; font-size: 0.75rem; font-weight: 500; border-radius: 9999px; }
                .priority-high .class-tag {
                    box-shadow: 0 0 7px currentColor;
                }
                .recruitment-apply { margin-top: 2.5rem; text-align: center; }
                .apply-title { font-size: 1.5rem; font-weight: 700; color: var(--color-red-500); margin-bottom: 1rem; }
                .apply-text { margin-bottom: 1.5rem; color: var(--color-slate-400); }
                
                /* --- USER PANEL PAGE --- */
                .user-panel-card { max-width: 42rem; margin: auto; background-color: rgba(15, 23, 42, 0.5); backdrop-filter: blur(4px); border-radius: 0.5rem; padding: 2rem; border: 1px solid rgba(185, 28, 28, 0.2); }
                .simulation-box { margin-bottom: 2rem; padding: 1rem; background-color: rgba(2, 6, 23, 0.5); border-radius: 0.5rem; border: 1px solid var(--color-slate-800); }
                .simulation-title { font-size: 1.125rem; font-weight: 600; margin-bottom: 0.75rem; color: var(--color-red-500); }
                .simulation-controls { display: flex; align-items: center; justify-content: space-between; }
                .role-selector { display: flex; align-items: center; gap: 0.5rem; }
                .role-label { color: var(--color-slate-300); font-size: 0.875rem; }
                .role-select { background-color: var(--color-slate-700); border: 1px solid var(--color-slate-600); border-radius: 0.25rem; padding: 0.25rem 0.5rem; font-size: 0.875rem; color: #fff; }
                .logged-out-view { text-align: center; color: var(--color-slate-500); }
                .logged-out-icon { margin: auto; height: 3rem; width: 3rem; margin-bottom: 1rem; }
                .logged-out-text { font-size: 1.25rem; font-weight: 600; }
                .welcome-message { font-size: 1.5rem; font-weight: 700; color: var(--color-red-500); }
                .user-role { text-transform: capitalize; }
                .options-text { color: var(--color-slate-400); margin-bottom: 1.5rem; }
                .permission-box { padding: 1rem; border-radius: 0.5rem; margin-bottom: 1rem; border-width: 1px; }
                .member-box { background-color: rgba(2, 6, 23, 0.5); border-color: var(--color-slate-800); }
                .officer-box { background-color: rgba(239, 68, 68, 0.1); border-color: rgba(239, 68, 68, 0.3); }
                .permission-title { font-size: 1.125rem; font-weight: 600; display: flex; align-items: center; gap: 0.5rem; }
                .officer-title { color: var(--color-red-400); }
                .permission-list { list-style-type: disc; list-style-position: inside; margin-top: 0.5rem; color: var(--color-slate-300); font-size: 0.875rem; display: flex; flex-direction: column; gap: 0.25rem; }

                /* --- FOOTER --- */
                .app-footer {
                  text-align: center;
                  color: var(--color-slate-600);
                  padding: 1.5rem 1rem;
                  font-size: 0.875rem;
                }

                /* --- RESPONSIVE STYLES --- */
                @media (min-width: 640px) {
                  .container { max-width: 640px; padding-left: 1.5rem; padding-right: 1.5rem; }
                  .roster-grid { grid-template-columns: repeat(2, 1fr); }
                  .progress-grid { grid-template-columns: repeat(2, 1fr); }
                }
                @media (min-width: 768px) {
                  .container { max-width: 768px; }
                  .main-nav { display: flex; }
                  .home-title { font-size: 5rem; }
                  .roster-grid { grid-template-columns: repeat(3, 1fr); }
                  .progress-grid { grid-template-columns: repeat(3, 1fr); }
                  .recruitment-grid { grid-template-columns: repeat(3, 1fr); }
                }
                @media (min-width: 1024px) {
                  .container { max-width: 1024px; padding-left: 2rem; padding-right: 2rem; }
                  .roster-grid { grid-template-columns: repeat(4, 1fr); }
                  .progress-grid { grid-template-columns: repeat(4, 1fr); }
                }
                @media (min-width: 1280px) {
                  .container { max-width: 1280px; }
                }

            `}</style>

            <SmolderingEmbersBackground />
            
            <div className="app-wrapper">
                <Header navigate={navigate} currentPage={currentPage} />
                <main className="main-content">
                    {renderPage()}
                </main>
                <Footer />
            </div>
        </div>
    );
};

export default App;